/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConcessionsPercentage1
 */
export interface ConcessionsPercentage1 {
}

/**
 * Check if a given object implements the ConcessionsPercentage1 interface.
 */
export function instanceOfConcessionsPercentage1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConcessionsPercentage1FromJSON(json: any): ConcessionsPercentage1 {
    return ConcessionsPercentage1FromJSONTyped(json, false);
}

export function ConcessionsPercentage1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ConcessionsPercentage1 {
    return json;
}

export function ConcessionsPercentage1ToJSON(value?: ConcessionsPercentage1 | null): any {
    return value;
}

